<app-section-wrapper-container>
	@if (recordData()?.type !== vehicleTypeEnum.BICYCLE) {
		<div class="flex flex-col sm:flex-row gap-4">
			<app-summary-box-item
				[title]="'vehicles|record|odometer-section|title'"
				[value]="
					recordData().odometerValue && recordData().odometerUnit
						? recordData().odometerValue + ' ' + recordData().odometerUnit
						: recordData().odometerValue || recordData().odometerUnit
				" />

			<app-summary-box-item
				[title]="'vehicles|record|details-section|field-label|doors'"
				[value]="recordData().doors" />

			<app-summary-box-item
				[title]="'vehicles|record|details-section|field-label|seats'"
				[value]="recordData().seats" />
		</div>
	}

	<div class="overview-sub-section">
		<app-summary-item
			[title]="'vehicles|record|details-section|field-label|type'"
			[value]="
				this.recordData().type
					| getTranslationKeyFromValue: typeOptions
					| transloco
			"></app-summary-item>
	</div>

	<div class="flex gap-4">
		<div class="overview-sub-section">
			<app-summary-item
				[title]="'vehicles|display-section|field-label|license-plate'"
				[value]="this.recordData().licensePlate" />
		</div>

		<div class="overview-sub-section">
			<app-summary-item
				[title]="'vehicles|record|make-model-section|title'"
				[value]="this.recordData().makeFull" />
		</div>
	</div>

	@if (recordData()?.type !== vehicleTypeEnum.BICYCLE) {
		<app-vehicle-links-status
			[recordData]="recordData()"
			[statusTracking]="statusTracking()" />
	}

	<div class="flex gap-4 flex-col md:flex-row">
		@if (recordData().vehicleCategoryId) {
			<app-vehicle-category-link-card [id]="recordData().vehicleCategoryId" />
		}

		@if (recordData().locationId) {
			<app-location-link-card [id]="recordData().locationId" />
		}
	</div>
</app-section-wrapper-container>
